/**
 * event-date-filter.js  —  Preserved Oakland / Palo Alto Theme
 * ─────────────────────────────────────────────────────────────────
 * Hides past events/classes on the collection page.
 *
 * HOW TO INSTALL:
 *   1. Shopify Admin → Online Store → Themes → Edit code
 *   2. Replace the existing Assets/event-date-filter.js with this file
 *   3. The {% if template.name == 'collection' %} script tag you already
 *      added to layout/theme.liquid does not need to change.
 *
 * HOW IT WORKS:
 *   Targets div.product-grid-item[data-tagged-class="true"] — the exact
 *   wrapper the Palo Alto theme outputs for products tagged "Class".
 *   Reads the date from .product-badge__item--custom span (e.g. "Sun 3/1").
 *   Hides the entire card div if that date is before today.
 *
 * DATE RULES:
 *   • Badge format  →  "Thu 3/5"  (abbrev-day  month/day)
 *   • Events happening TODAY are kept visible.
 *   • In December, badges dated Jan or Feb are treated as next year.
 *   • Hide Buttons List if no matching events
 * ─────────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  var DATE_PATTERN = /(\d{1,2})\/(\d{1,2})/;

  function parseBadgeDate(text, today) {
    var match = text.match(DATE_PATTERN);
    if (!match) return null;

    var month = parseInt(match[1], 10);
    var day   = parseInt(match[2], 10);
    if (month < 1 || month > 12 || day < 1 || day > 31) return null;

    var currentMonth = today.getMonth() + 1;
    var year = today.getFullYear();
    if (currentMonth === 12 && month <= 2) year += 1;

    return new Date(year, month - 1, day, 0, 0, 0, 0);
  }

  var MONTH_NAMES = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];

  function filterButtons(visibleMonthNumbers) {
  var MONTH_NAMES = ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];

  var carousel = document.querySelector('grid-slider');
  if (!carousel) return;

  var flkty = carousel.flkty; // ← this is the key fix

  var toRemove = [];
  document.querySelectorAll('a.list-collections__item__outer[href*="/collections/events-classes/"]').forEach(function(link) {
    var titleEl = link.querySelector('.list-collections__item__title');
    if (!titleEl) return;
    var label = titleEl.textContent.trim().toLowerCase();
    var monthIndex = MONTH_NAMES.indexOf(label);
    if (monthIndex === -1) return;
    if (!visibleMonthNumbers.has(monthIndex + 1)) {
      toRemove.push(link.closest('.list-collections__item'));
    }
  });

  if (!toRemove.length) return;

  if (flkty) {
    flkty.remove(toRemove); // Flickity removes cells AND reflows
  } else {
    toRemove.forEach(function(el) { if (el && el.parentNode) el.parentNode.removeChild(el); });
  }

  console.log('[event-date-filter] Removed ' + toRemove.length + ' month buttons.');
  }

  function run() {
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var cards = document.querySelectorAll('.product-grid-item[data-tagged-class="true"]');
    var hiddenCount = 0;
    var visibleMonths = new Set();

    cards.forEach(function (card) {
      var badgeSpan = card.querySelector('.product-badge__item--custom span');
      if (!badgeSpan) return;

      var text = badgeSpan.textContent.trim();
      var eventDate = parseBadgeDate(text, today);

      if (!eventDate) {
        console.warn('[event-date-filter] Could not parse date from badge:', text);
        return;
      }

      if (eventDate < today) {
        card.style.display = 'none';
        card.setAttribute('aria-hidden', 'true');
        hiddenCount++;
      } else {
        // Card is visible — record its month
        visibleMonths.add(eventDate.getMonth() + 1);
      }
    });

    console.log('[event-date-filter] Checked ' + cards.length + ' class cards, hid ' + hiddenCount + '.');

    filterButtons(visibleMonths);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();